<template>
  <div class="localita-view">
    <button class="close-button" @click="close">×</button>
    <template v-if="localitaList && localitaList.length > 0">
      <h2>Località Individuate</h2>
      <h5>Localitè selezionate: {{ selectedLocalita.length }} (Totale: {{ totalPopulation }})</h5>
      <ul class="list-group">
        <li v-for="localita in localitaList" :key="localita.nome" class="list-group-item"
          :class="{ 'selected': isSelected(localita) }" @click="toggleSelection(localita)">
          <strong>{{ localita.nome }}</strong> - {{ localita.distanza.toFixed(2) }} km - Popolazione: {{
            localita.popolazione }}
        </li>
      </ul>
    </template>
    <template v-else>
      <h2>Località Individuate</h2>
      <p>Nessuna località individuate.</p>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    localitaList: {
      type: Array,
      required: false,
      default: () => [],
    },
    selectedLocalita: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    totalPopulation() {
      return this.selectedLocalita.reduce((total, localita) => {
        // Converti popolazione in numero prima di sommare
        const popolazione = Number(localita.popolazione) || 0;
        return total + popolazione;
      }, 0);
    }
  },
  methods: {
    close() {
      this.$emit("closeLocalita"); // Emetti l'evento per chiudere la vista Località
    },
    toggleSelection(localita) {
      this.$emit("select-localita", localita);
    },
    isSelected(localita) {
      return this.selectedLocalita.some(l => l.nome === localita.nome);
    },
  },
};
</script>

<style scoped>
.localita-view {
  padding: 20px;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.list-group-item {
  cursor: pointer;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  transition: background-color 0.3s ease;
}

.list-group-item:hover {
  background-color: #f8f9fa;
}

.list-group-item.selected {
  background-color: #ffc107;
  border-left: 4px solid #6c757d;
}
</style>